import { getNodeDefinitions, type NodeDefinitionRow, type NodeDefinitionsQuery } from '../endpoints/getNodeDefinitions';

export type SearchNodeDefinitionsParams = NodeDefinitionsQuery;

export interface NodeDefinitionsPage {
  readonly items: readonly NodeDefinitionRow[];
  readonly total: number;
}

/**
 * One page of node definitions matching `params`, reshaped for the async dropdown. `total` is the server-side count of all
 * matches (not the page size), so callers can render "showing N of total" and decide whether more pages exist. `undefined`
 * params are dropped by axios, so omitting `search` / `zone_name` widens the query rather than filtering on empty.
 */
export const searchNodeDefinitions = async (params: SearchNodeDefinitionsParams): Promise<NodeDefinitionsPage> => {
  const { nodes, pagination } = await getNodeDefinitions(params);
  return { items: nodes, total: pagination.total_records };
};
